import { Input, Text } from "@mantine/core";
import React from "react";

import styles from "./YachtSetup.module.scss";

export const FlexRow: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.flexRow} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const VesselParticularsContainer: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div
    className={`${styles.vesselParticularsContainer} ${className ?? ""}`}
    {...rest}>
    {children}
  </div>
);

export const VesselParticularsGrid: React.FC<
  React.HTMLAttributes<HTMLDivElement> & {
    twoColumn?: boolean;
    singleSection?: boolean;
  }
> = ({ children, className, twoColumn, singleSection, ...rest }) => (
  <div
    className={`${styles.vesselParticularsGrid} ${twoColumn ? styles.twoColumn : ""} ${singleSection ? styles.singleSection : ""} ${className ?? ""}`}
    {...rest}>
    {children}
  </div>
);

export const VesselParticularsCard: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div
    className={`${styles.vesselParticularsCard} ${className ?? ""}`}
    {...rest}>
    {children}
  </div>
);

export const VesselSectionTitle: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div className={`${styles.vesselSectionTitle} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const FieldsSection: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div className={`${styles.fieldsSection} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const InputStyledWrapper: React.FC<
  React.ComponentProps<typeof Input.Wrapper>
> = props => (
  <Input.Wrapper className={styles.inputStyledWrapper} {...props} />
);
